(function () {
  // Fountains that skip the cart and go straight to checkout (with their free gifts).
  // = the "Website - Fountains" saved view in Shopify admin (products tagged "Web Fountain").
  // Keep in sync if that view changes.
  const FOUNTAIN_PRODUCT_IDS = new Set([
    7687835353308, // metalbundles — Health & Happiness Cat Kit (4L)
    8369671045340, // kittyspout-wireless-fountain
    8764283158748, // kittyspout2_0
    8932735647964, // 2-2l-fountain
    9244927262940, // colored-wireless2 — Wireless Fountain 2.0
    15450357956828, // wireless-fountain-2-0-2-5l — Wireless Fountain 2.0 (2.5L), F10
    // Prime gift card split-test copies (unlisted, + free $10 gift card), not in the saved view:
    10324182892764, // the-kittyspout™-2-2l-fountain-health-and-happiness-kit-prime (2.2L)
    10324155793628, // the-kittyspout™-health-happiness-cat-kit-prime (4L)
    10324185972956  // the-kittyspout™-wireless-fountain-2-prime (Wireless 2.0)
  ]);

  if (window.__ksStraightToCheckout) return;
  window.__ksStraightToCheckout = true;

  function closeCartDrawer() {
    if (!document.getElementById('ks-stc-hide-drawer')) {
      const s = document.createElement('style');
      s.id = 'ks-stc-hide-drawer';
      s.textContent = '#CartDrawer,#cd-overlay{display:none!important;visibility:hidden!important;opacity:0!important;}';
      document.head.appendChild(s);
    }
    document.body.classList.remove('cd-open', 'drawer-open', 'overflow-hidden');
    document.documentElement.classList.remove('cd-open', 'drawer-open', 'overflow-hidden', 'js-drawer-open', 'js-drawer-open--right');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function isFountainLine(item) {
    if (!item || !FOUNTAIN_PRODUCT_IDS.has(Number(item.product_id))) return false;
    return !(item.properties && item.properties._gift);
  }

  // Redirect only AFTER the add has succeeded. The fountain and its gifts go in the same
  // /cart/add.js request, so by then they are all in the cart. The old version redirected on a
  // blind 1.2 s timer, which on slow mobile connections cut the add off mid-request: Safari
  // reported "Load failed" (shown as a pop-up) and shoppers could reach checkout without the
  // fountain or gifts.
  function goToCheckout() {
    if (window.__ksCheckoutRedirecting) return;
    window.__ksCheckoutRedirecting = true; // product-form-atc.js skips error pop-ups while this is set
    closeCartDrawer();
    window.location.assign('/checkout');
  }

  const origFetch = window.fetch;
  if (!origFetch) return;

  window.fetch = function (input, init) {
    let url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (_) {}
    const promise = origFetch.apply(this, arguments);

    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      promise.then(function (res) {
        if (!res || !res.ok) return;
        res.clone().json().then(function (data) {
          const items = Array.isArray(data && data.items) ? data.items : [data];
          if (items.some(isFountainLine)) goToCheckout();
        }).catch(function () {});
      }).catch(function () {});
    }

    return promise;
  };
})();
